import React from "react";
import { useSelector } from "react-redux";
import { useRouteMatch, useHistory } from "react-router-dom";
import PropTypes from "prop-types";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import Kebabs from "../../assets/img/icons/icon-kebabs-black.svg";

const ContextMenu = ({
  content,
  eventId,
  updateTrigger,
  activityEventName,
  dropdownOpen,
  toggle,
}) => {
  const update = React.useCallback(
    (e) => {
      e.preventDefault();
      return updateTrigger({
        id: eventId,
        status: content === "INACTIVE" ? "ACTIVE" : "INACTIVE",
      });
    },
    [eventId, content, updateTrigger],
  );

  const client = useSelector((state) => state.client.data);

  const canEdit = Number(client?.isMassEmailEnabled) === 1;

  const { path } = useRouteMatch("/communications");
  const history = useHistory();

  const workflowRoute = React.useCallback(() => {
    const url = `${path}/automatic/${activityEventName}/workflow/edit`;

    history.push(url);
  }, [path, history, activityEventName]);

  return (
    <Dropdown isOpen={dropdownOpen} toggle={toggle}>
      <DropdownToggle>
        <Kebabs className="pp_comms_kebab" />
      </DropdownToggle>
      <DropdownMenu className="dropright dropdown-menu-right">
        <DropdownItem header>Actions</DropdownItem>
        <DropdownItem onClick={update}>
          Set to {content === "INACTIVE" ? "Active" : "Inactive"}
        </DropdownItem>
        <DropdownItem disabled={canEdit === false} onClick={workflowRoute}>
          Edit
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
};

ContextMenu.propTypes = {
  content: PropTypes.string.isRequired,
  activityEventName: PropTypes.string.isRequired,
  updateTrigger: PropTypes.func.isRequired,
  eventId: PropTypes.number.isRequired,
  dropdownOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
};

export default ContextMenu;
